import React, { useEffect, useState } from "react";
import "./index.css";
import newLogo from "../../../../assets/images/newLogo.png";
import { Form, Input } from "antd";
import axios from "axios";
import { switchEndpoint } from "../../../../redux/actions/endpoints";
import { toast } from "react-toastify";
import { storage } from "../../../../scopedStorage";

const FactoryLogin = (props) => {
  const [loading, setLoading] = useState(false);
  // const [loginData, setLoginData] = useState({
  //   email: "abiodun@switchrecycling.com",
  //   password: "abiodun",
  // });

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const handleLoginForm =
    (name) =>
      ({ target }) => {
        setLoginData({
          ...loginData,
          [name]: target.value,
        });
      };

  let payload = {
    email: loginData.email,
    password: loginData.password,
  };

  const handleLogin = async () => {
    setLoading(true);

    const toastConfig = {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      pauseOnHover: true,
      progress: undefined,
      theme: "light",
    };

    try {
      const response = await axios.post(
        `${switchEndpoint}/auth/login-email`,
        payload
      );
      const { data } = response;
      const { customer, token, message } = data;

      if (customer.roles[0] === "factory") {
        const { factory } = customer;

        // Store user data in localStorage
        storage.setItem("token", token);
        storage.setItem("centerInfo", JSON.stringify(customer));
        toast.success(message, toastConfig);
        props.history.push("/factory");
      } else {
        toast.error("Unauthorized", toastConfig);
      }
    } catch (error) {
      // console.log(error);
      toast.error(error?.response?.data?.message, toastConfig);
    } finally {
      setLoading(false);
    }
  };

  const validate = () => {
    if (!loginData.email) {
      toast.error("Email not provided !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (!loginData.password) {
      toast.error("Password not provided !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    handleLogin();
  };

  useEffect(() => {
    storage.clearScoped();
  }, []);

  return (
    <div>
      <div className="row noMarginPadding">
        <div className="col-xl-6 col-lg-8 col-md-8 col-sm-8 col-xs-12 PaddingLeft-10">
          <div className="container pl-4 pt-4 PaddingLeft-10">
            <div style={{ width: "150px" }}>
              <img src={newLogo} alt="logo" style={{ width: "100%" }} />
            </div>
            <div className="w-75 ml-5 mt-5 containerWidth">
              <h5 className="headerText headerh5">Logistics Manager</h5>
              <p className="loginStyle mb-0">Login</p>
              <div className="form-group">
                <label className="label-control mb-0 labelStyle">
                  Email Address
                </label>
                <input
                  type="email"
                  className="form-control inputStyle"
                  placeholder="Enter email address"
                  // no-border
                  value={loginData.email}
                  onChange={handleLoginForm("email")}
                />
              </div>
              <div>
                <label className="label-control mb-0 labelStyle">
                  Enter Password
                </label>
                <Form>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                    value={loginData.password}
                    onChange={handleLoginForm("password")}
                  >
                    <Input.Password placeholder="*************" />
                  </Form.Item>
                </Form>
              </div>

              <div className="forgotPassword">
                <div></div>
                <div className="fpw">
                  <a
                    href="/factoryForgotPassword"
                    style={{ color: "#231F20", fontSize: "13px" }}
                  >
                    Forgot Password{" "}
                    <span style={{ color: "#c4da00" }}>&#62;</span>
                  </a>
                </div>
              </div>

              <button
                type="button"
                className="btn loginBtn btn-sm btn-block"
                onClick={validate}
                disabled={loading}
              >
                Login
              </button>
            </div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-4 col-md-4 rightImg"></div>
      </div>
    </div>
  );
};

export default FactoryLogin;
